import { deferred } from "lib/actions/util";

export class DeferredValue<T> {
  private _value: T = null;
  private _deferred = deferred<T>();

  get current() {
    return this._value;
  }

  /**
   * @returns Promise that will resolve when the deferred value
   * is available, or null if the defer was cancelled.
   * */
  async getValueWhenReady() {
    if (this._deferred) return (await this._deferred).value;
    return this._value;
  }

  set(value: T) {
    this._value = value;
    this._deferred?.ready(value);
    this._deferred = null;
  }

  clear() {
    this._value = null;
    this._deferred?.dispose();
    this._deferred = deferred();
  }
}
